/**
 * PATH: apps/quote/src/components/builder/paste-mapping-modal/PreviewTable.tsx
 * PURPOSE: Preview table showing mapped paste data
 */

import { AlertTriangle } from 'lucide-react'
import type { ColumnMapping, PasteMappingModalProps } from './types'

export function PreviewTable({ data, mappings, availableFields }: {
  data: string[][]; mappings: ColumnMapping[]; availableFields: PasteMappingModalProps['availableFields']
}) {
  const mappedFields = mappings.map(m => {
    const field = availableFields.find(f => f.id === m.targetField)
    return { ...m, field }
  }).filter(m => m.field)

  if (mappedFields.length === 0) {
    return (<div className="text-center py-8 text-slate-400"><AlertTriangle className="w-8 h-8 mx-auto mb-2" /><p>No columns mapped yet</p></div>)
  }

  const previewRows = data.slice(1, 6)
  return (
    <div className="border rounded overflow-hidden">
      <table className="w-full text-xs">
        <thead className="bg-slate-100 dark:bg-slate-800">
          <tr>
            <th className="px-2 py-1.5 text-left font-medium text-slate-600 dark:text-slate-400">#</th>
            {mappedFields.map(({ field }) => (<th key={field!.id} className="px-2 py-1.5 text-left font-medium text-slate-600 dark:text-slate-400">{field!.label}</th>))}
          </tr>
        </thead>
        <tbody>
          {previewRows.map((row, rowIdx) => (
            <tr key={rowIdx} className="border-t border-slate-100 dark:border-slate-800">
              <td className="px-2 py-1.5 text-slate-400">{rowIdx + 1}</td>
              {mappedFields.map(({ sourceIndex, field }) => (<td key={field!.id} className="px-2 py-1.5 text-slate-900 dark:text-white">{row[sourceIndex] || '-'}</td>))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
